import { useApi } from "@backstage/core-plugin-api";
import { useCallback, useEffect } from "react";
import { useAsyncFn } from "react-use";
import { opsReviewApiRef } from "../api/OpsReviewApi";

export interface Props {
  date: string;
}

export const useHistoricalReference = ({ date }: Props) => {
  const api = useApi(opsReviewApiRef);

  const getData = useCallback(async () => {
    const { data } = await api.getHistoricalReference({ date });
    return data;
  }, [api, date]);

  const [state, fetchData] = useAsyncFn(async () => {
    const resp = await getData();
    if (resp.error) {
      state.error = resp;
    }
    return resp;
  }, [getData]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return {
    loading: state.loading,
    error: state.error,
    value: state?.value,
    fetchData,
  };
};
